import { render, staticRenderFns } from "./DirectorySwitcher.vue?vue&type=template&id=33449e1e&"
import script from "./DirectorySwitcher.vue?vue&type=script&lang=js&"
export * from "./DirectorySwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports